var exports = {
  "YL": "Tooltip.module__tooltip___UU1Rcn",
  "xQ": "Tooltip.module__tooltipPointer___UU1Rcn",
  "rv": "Tooltip.module__tooltipContent___UU1Rcn",
  "iU": "Tooltip.module__tooltipContentLarge___UU1Rcn" + " " + "Tooltip.module__tooltipContent___UU1Rcn",
  "dn": "Tooltip.module__tooltipTop___UU1Rcn",
  "L_": "Tooltip.module__tooltipBottom___UU1Rcn",
  "Lf": "Tooltip.module__tooltipLeft___UU1Rcn",
  "Uu": "Tooltip.module__tooltipRight___UU1Rcn",
  "A4": "Tooltip.module__tooltipPrimary___UU1Rcn",
  "yH": "Tooltip.module__tooltipPointerBg___UU1Rcn",
  "Rp": "Tooltip.module__tooltipRed___UU1Rcn",
  "vX": "Tooltip.module__tooltips___UU1Rcn",
  "bZ": "Tooltip.module__hoverFloatingTooltipSurface___UU1Rcn",
  "IM": "Tooltip.module__triggerWrapper___UU1Rcn",
};

module.exports = exports;
